import React from 'react';
import NavbarComponent from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Experience from './components/Experience';
import Skills from './components/Skills';
import Publications from './components/Publications';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Privacy from './components/Privacy';
import Terms from './components/Terms';

function Home() {
  return (
    <>
      <NavbarComponent />
      <Hero />
      <About />
      <Experience />
      <Skills />
      <Publications />
      <Contact />
      <Footer />
    </>
  );
}

function App() {
  const path = window.location.pathname.replace(/\/+$/, '') || '/';

  let page;
  switch (path) {
    case '/privacy':
      page = <Privacy />;
      break;
    case '/terms':
      page = <Terms />;
      break;
    default:
      page = <Home />;
  }

  return <div className="App">{page}</div>;
}

export default App;
